import React from 'react'

export const NotFound = () => {
    return (
        <div style={{ color: "white" }}>Error 404: the page you are trying to access does not exist</div>
    )
}
